// extracted by mini-css-extract-plugin
export default {"main":"MobileNavBar_main__iySeP","active-tab":"MobileNavBar_active-tab__t0lw5"};